<div class="page-style1 h-100 w-100 light-mode default-sidebar error-page1">
  <div class="login-img">
    <picture>
      <source media="(min-width:800px)" srcset="../../../assets/images/brand/Ativo2.webp">
      <img class="login-img-efeito" src="../../../assets/images/brand/Ativo 3.webp" alt="">
    </picture>
    <div class="page">
      <div class="container">
        <div class="planeta">
          <!--Textures from https://www.solarsystemscope.com/textures/ (Planet Earth) -->
          <img class="imgd" src="../../../assets/images/planeta/Efeitos.png" aria-hidden="true" alt="">
          <div class='planet-container'>
              <div class='night'></div>
              <div class='clouds'></div>
          </div>
        </div>
        <div class="row">
          <div class="col mx-auto container-login">
            <div class="row justify-content-center mt-4">
              <div class="col-md-8 col-lg-7 col-xl-5">
                <div class="login-logo">
                  <img class="icone-fundo" src="../../../assets/images/brand/icone-fundo.svg" aria-hidden="true" alt="">
                  
                  <ul ngbNav #nav="ngbNav" class="justify-content-center">
                    <li ngbNavItem="Angular">
                      <img
                        src="../../../assets/images/brand/logo-azul.svg" class="mb-4 img-fluid mx-auto" width="400"
                        alt="logo"
                      />
                      <ng-template ngbNavContent>
                        <form [formGroup]="loginForm" class="login-form">
                          <div *ngIf="!totpRequired">
                            <div class="text-center title-style mb-6">
                              <h1 class="mb-4 text-title-gray fs-4">Acesse sua conta</h1>
                            </div>
                            <div class="form-group mt-2">
                              <p
                                *ngIf="errorMessage.length > 0"
                                class="text-danger"
                              >
                                {{ errorMessage }}
                              </p>

                              <p
                                *ngIf="_error.message.length > 0"
                                class="text-danger"
                              >
                                {{ _error.message }}
                              </p>
                            </div>
                            <div class="input-group mb-4">
                              <span
                                class="input-group-text bg-primary text-muted"
                              >
                                <i
                                  class="mdi mdi-email text-white"
                                  aria-hidden="true"
                                ></i>
                              </span>
                              <input
                                type="text"
                                class="form-control"
                                placeholder="E-mail"
                                autocomplete
                                formControlName="username"
                                [(ngModel)]="username"
                              />
                            </div>
                            <div class="input-group mb-5">
                              <a
                                href="javascript:void(0)"
                                class="input-group-text bg-primary text-white"
                                (click)="togglePassword()"
                              >
                                <i
                                  [class.mdi-eye]="showPassword == false"
                                  [class.mdi-eye-off]="showPassword"
                                  class="mdi mdi-eye text-white"
                                  aria-hidden="true"
                                ></i>
                              </a>
                              <input
                                [type]="showPassword ? 'text' : 'password'"
                                class="form-control"
                                placeholder="Senha"
                                autocomplete
                                formControlName="password"
                                [(ngModel)]="password"
                              />
                            </div>
                            <button
                              [disabled]="showLoader"
                              (click)="continuar()"
                              class="btn btn-primary btn-block w-60 mx-auto btn-login"
                              autofocus
                              [class.loader--text]="showLoader"
                            >CONTINUAR</button>
                          </div>
                          <div *ngIf="totpRequired">
                            <div class="text-center title-style mb-6">
                              <h1 class="mb-4 text-title-gray fs-4">Informe o token 2FA</h1>
                            </div>
                            <div class="input-group mb-3">
                              <span
                                class="input-group-text bg-primary text-muted"
                              >
                                <i
                                  class="mdi mdi-lock text-white"
                                  aria-hidden="true"
                                ></i>
                            </span>
                              <input
                                type="text"
                                class="form-control"
                                placeholder="2FA"
                                autofocus
                                autocomplete
                                formControlName="totpCode"
                                [(ngModel)]="totpCode"
                                (keydown.enter)="submit()"
                              />
                            </div>
                            <button
                              [disabled]="showLoader"
                              (click)="pasteTotpCode()"
                              class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mb-5"
                              [class.loader--text]="showLoader"
                            >
                              Colar Aqui!
                            </button>
                            <button
                              [disabled]="showLoader"
                              (click)="submit()"
                              class="btn btn-primary btn-block btn-login w-60 mx-auto"
                              [class.loader--text]="showLoader"
                            >
                              CONECTE-SE
                            </button>
                          </div>
                        </form>
                      </ng-template>
                    </li>
                  </ul>

                </div>
                <div class="card p-4 card-login shadow">
                  <div class="card-body">
                    <div class="loading-login" *ngIf="showLoader">
                      <div class="dimmer active">
                        <div class="lds-ring">
                          <div></div>
                        </div>
                      </div>
                    </div>
                    <div [ngbNavOutlet]="nav" class="ml-4"></div>
                  </div>
                </div>
                  <div class="d-flex justify-content-center pt-4 mb-4 ">
                    <a href="" class="col-4 p-2" target="_blank" rel="noopener"><img  src="../../../assets/images/planeta/Loja Apple.png" alt="App Store"></a>
                    <a href="https://play.google.com/store/apps/details?id=br.com.digitopayoficial.digitopay_app&pcampaignid=web_share&pli=1" class="col-4 p-2" target="_blank" rel="noopener"><img  src="../../../assets/images/planeta/Loja Google.png" alt="Google Play"></a>
                  </div>
                <div class="sobre">
                  <h2 class="fs-4 w-45 text-white col-sm ">A melhor
                    <span class="text-primary d-block">
                      processadora
                      de pagamentos
                    </span>
                    do mercado
                  </h2>
                  <p class="text-white fs-7 w-60 col-sm text-start">
                    Nossa missão é facilitar as operações financeiras do seu negócio, e poder agregar nele Tecnologia, Segurança e
                    Modernidade!
                  </p>
                </div>
                  <img src="../../../assets/images/brand/vazio.png" width="200" aria-hidden="true" class="tela" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #change2FA let-modal>
  <!--  SMALL MODAL -->
  <div *ngIf="!isQRCodeChecked">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Dupla autenticação 2FA</h5>
      </div>
      <div class="modal-body">
        <p>
          Para configurar a dupla autenticação, recomendamos o uso do Google
          Authenticator. É uma forma fácil e segura de adicionar uma camada
          extra de proteção à sua conta. Para configurar o Google Authenticator,
          siga estes passos:
        </p>
        <ol>
          <li>
            Baixe o aplicativo Google Authenticator na sua loja de aplicativos.
          </li>
          <li>
            Abra o aplicativo Google Authenticator e escaneie o código QR
            exibido na tela.
          </li>
          <li>
            Insira o código gerado pelo Google Authenticator na caixa de
            diálogo.
          </li>
          <li>
            Salve suas configurações e pronto! Sua conta agora está protegida
            com a dupla autenticação.
          </li>
        </ol>
        <p>
          Lembre-se de que é importante guardar o seu dispositivo móvel em um
          local seguro, pois ele será a única forma de acessar a sua conta com a
          dupla autenticação ativada.
        </p>
      </div>
      <div class="modal-footer text-center">
        <button
          type="submit"
          class="btn btn-lg btn-primary btn-pill mx-auto d-block"
          (click)="isQRCodeChecked = true"
        >
          ENTENDI
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="isQRCodeChecked">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Configure a dupla autenticação:</h5>
      </div>
      <div class="modal-body">
        <div class="form-group mt-2">
          <p *ngIf="errorMessage.length > 0" class="text-danger">
            {{ errorMessage }}
          </p>
        </div>
        <div class="form-group mb-3 text-center">
          <img id="qrCode" alt="qrCode" [src]="qrCode" />
        </div>
        <div class="form-group mb-3 text-center">
          <textarea
            class="form-control"
            [ngModel]="manualCode"
            disabled
          ></textarea>
          <button
            class="btn btn-primary"
            placement="top"
            ngbPopover="Copiado!"
            [cdkCopyToClipboard]="manualCode"
            style="margin-top: 3px"
          >
            Copiar
          </button>
        </div>
        <div class="form-group mb-3">
          <input
            type="text"
            class="form-control"
            id="totp"
            placeholder="Código de autenticação"
            autofocus
            autocomplete
            [(ngModel)]="validationCode"
          />
        </div>
      </div>
      <div class="modal-footer text-center">
        <button
          type="submit"
          class="btn btn-lg btn-primary btn-pill mx-auto d-block"
          (click)="validateFirstTotp()"
        >
          VALIDAR
        </button>
      </div>
    </div>
  </div>
</ng-template>
